import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { OrganisationResponse } from '../../Models/Models/Customer/OrganisationResponse';
import { Organisation } from '../../Models/Models/Customer/Organisation';

declare var IS_RUNNING_IN_APP_POOL;

export class OrganisationClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public post(organisation: Organisation): Promise<OrganisationResponse, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Customer/Organisation/Post';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { organisation: organisation }

    return AjaxWrapper.post<OrganisationResponse, any>(url, data);
  }
  public get(customerId: number, hierarchyId: string): Promise<Organisation, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Customer/Organisation/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { customerId: customerId, hierarchyId: hierarchyId }

    return AjaxWrapper.get<Organisation, any>(url, data);
  }
  public put(organisation: Organisation): Promise<Organisation, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Customer/Organisation/Put';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { organisation: organisation }

    return AjaxWrapper.put<Organisation, any>(url, data);
  }
}

